import { Component, OnInit } from '@angular/core';
import { Globals } from "../../_models/globals";
import { ApiIntegration } from "../../_services/api.integration";
import { ActivatedRoute } from "@angular/router";
import { User } from '../../_models/user';
@Component({
  selector: 'app-shipment-view',
  templateUrl: './shipment-view.component.html',
  styleUrls: ['./shipment-view.component.css']
})
export class ShipmentViewComponent implements OnInit {
  shipmentline: any;
  constructor(private g: Globals, public user: User, private api: ApiIntegration, private route: ActivatedRoute) {
    this.g.page = "Shipment View";
    this.api.getShipmentsLines(this.route.snapshot.params['id']).subscribe((data: any) => { this.shipmentline = data; }, err => { console.log(err); });
  }
  ngOnInit() {
  }

}
